import React from 'react';
import Icon, { IconProps } from './Icon';

/**
 * Check icon for representing success or completion
 */
export const CheckIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <polyline points="20 6 9 17 4 12"></polyline>
    </Icon>
  );
};

export default CheckIcon;
